import type { NavItem } from "../nav";

export function PlaceholderPage({ item }: { item: NavItem }) {
  return (
    <>
      <h1>{item.label}</h1>
      <p className="muted">Not built yet{item.arrives ? `: it arrives in phase ${item.arrives}` : ""}.</p>
    </>
  );
}
